const Project = () => {
    return (
        <article></article>
    )
}

export default Project
